export default __webpack_public_path__ + "static/media/archieve.43cf15e2.svg";